import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { setOutputField } from 'actions/feature/outputs'
import {
  getDisabledCanOutputBits,
  getOutputQueryType,
  getSingleConditionMetaData,
  getOutputOptions,
  getHasNativeOutput,
} from 'selectors/feature/outputs'
import { getValidationDescriptions } from 'selectors/feature/features'
import { harnessPinIdSetSelector } from 'selectors/feature/harnesses'
import { getAvailableLogicNodesMeta } from 'selectors/feature/logicNodes'
import {
  getFeatureModuleName,
  getFeatureType,
} from 'selectors/feature/featureMetadata'

import { TIMER } from 'utils/constants'
import OutputFormSection from './OutputFormSection'

const makeMapStateToProps = () => (state, ownProps) => {
  const {
    output: { id, fnId },
    featureModuleType,
  } = ownProps
  const outputQueryType = getOutputQueryType(state, { fnId })
  const disabledBits = getDisabledCanOutputBits(id)(state)
  const validUris = getAvailableLogicNodesMeta(state, { id })

  const { disableSixteenBit } = getSingleConditionMetaData(state, {
    id,
    fnId,
  })
  const allDescriptions = getValidationDescriptions(state)
  const outputOptions = getOutputOptions(state, {
    id,
    featureModuleType,
  })
  const pinSet = harnessPinIdSetSelector(state)
  const featureModuleName = getFeatureModuleName(state)
  const featureType = getFeatureType(state)
  const isNativeOutput = getHasNativeOutput(state, { id: fnId })
  return {
    ...ownProps,
    featureModuleType,
    featureModuleName,
    disabledBits,
    outputOptions,
    isTimerOutputQuery: outputQueryType === TIMER,
    isNativeOutput,
    disableSixteenBit,
    allDescriptions,
    pinSet,
    featureType,
    validUris,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const {
    output: { id },
  } = ownProps

  return {
    ...bindActionCreators(
      {
        updateNumberOfBits: (event) =>
          setOutputField('numberOfBits', event.target.value, id),
        updateStartBit: (num) => setOutputField('startBit', num, id),
        setSelectedOutput: (mappedOutputId) =>
          mappedOutputId !== null
            ? setOutputField('mappedOutputId', mappedOutputId, id)
            : null,
        setFloatingCircuit: (floatingCircuit) =>
          setOutputField('floatingCircuit', floatingCircuit, id),
        setPinDescription: (value) => setOutputField('description', value, id),
        updateOutputOperator: (event) =>
          setOutputField('operator', parseInt(event.target.value), id),
        updateOutputTimerValue: (value) => setOutputField('value', value, id),
        updatePowerNetLevel: (value) =>
          setOutputField('powerNetLevel', value, id),
        updateOutputIsAwake: (value) => setOutputField('isAwake', value, id),
      },
      dispatch
    ),
  }
}

export default connect(
  makeMapStateToProps,
  mapDispatchToProps
)(OutputFormSection)
